export const ccType = [
  { val: "CC", name: "CC" },
  {
    val: "CE",
    name: "CE",
  },
  { val: "PE", name: "PE" },
  { val: "PT", name: "PT" },
];
